import { Component, OnInit } from '@angular/core';
import { AdminServiceService } from 'src/app/services/admin-service.service';
import { MipsService } from 'src/app/services/mips.service';
import Swal from 'sweetalert2';

declare var $:any;
@Component({
  selector: 'app-mips-questions',
  templateUrl: './mips-questions.component.html',
  styles: [
  ]
})
export class MipsQuestionsComponent implements OnInit {

  public text = "";
  public index = 999;
  public loadingScales = false;
  public questions = [];
  public scales = [];
  public valueIndex = 1;
  public score = 1;
  public trueItems = [];
  public falseItems = [];
  public selectedScale = "";
  public isEditing = false;
  public _id;
  public editingIndex = 0;
  public cogn = true;
  public motiv = true;
  public interp = true;
  public validez = true;

  constructor(
    private mipsService:MipsService,
    private adminService:AdminServiceService
  ) { }

  ngOnInit(): void {
    this.mipsService.getScales().subscribe(
      resp=>{
        this.scales = resp;
      },
      err=>console.log(err)
    )
    this.mipsService.getQuestions().subscribe(
      resp=>{
        this.questions = resp;
      },
      err=>console.log(err)
    )
  }

  addTrue(){
    this.trueItems.push({index:this.valueIndex-1, score:this.score});
    $('#index').focus();
    this.valueIndex=null;
    this.score=null;
  }

  addFalse(){
    this.falseItems.push({index:this.valueIndex-1, score:this.score});
    $('#index').focus();
    this.valueIndex=null;
    this.score=null;
  }

  async setCorrelations(){
    this.loadingScales = true;
    for (let i of this.trueItems){
      let values = this.questions[i.index].values;
      let aux = {
        scale:this.selectedScale,
        value:true,
        score:i.score
      }
      let founded = false;
      values.map(
        v=>{
          if (v.scale==aux.scale&&v.value==aux.value) founded = true;
        }
      )
      if (!founded){
        values.push(aux);
        let obj = {
          value: true,
          values: values,
          _id:this.questions[i.index]._id
        }
        let res = await this.mipsService.updateQuestion(obj).toPromise();
      } 

    }
    for (let i of this.falseItems){
      let values = this.questions[i.index].values;
      let aux = {
        scale:this.selectedScale,
        value:false,
        score:i.score
      }
      let founded = false;
      values.map(
        v=>{
          if (v.scale==aux.scale&&v.value==aux.value) founded = true;
        }
      )
      if (!founded) {
        values.push(aux);
        let obj = {
          value: false,
          values: values,
          _id:this.questions[i.index]._id
        }
        let res = await this.mipsService.updateQuestion(obj).toPromise();
      } 
    }
    this.loadingScales = false;
    this.trueItems = [];
    this.falseItems = [];
    location.reload();
  }

  reload(){
    window.location.reload();
  }

  restoreItem(i,it,t){
    let values = this.questions[it.index].values;
    let index = 0;
    let pos = 0;
    values.map(
      v=>{
        if (v.scale==this.selectedScale) pos = index;
        index++;
      }
    )
    values.splice(pos,1);
    let obj = {
      values: values,
      _id:this.questions[it.index]._id
    }
    this.mipsService.updateQuestion(obj).subscribe();
    if (t){
      this.trueItems.splice(i, 1)
    }else{
      this.falseItems.splice(i,1)
    }
  }

  addQuestion(){
    let obj = {
      title: this.text,
      index: this.index,
    }
    this.mipsService.createQuestion(obj).subscribe(
      resp=>{
        this.questions.push(obj);
        this.selectedScale = "";
        this.text = "";
        this.index = 999;
      },
      err=>console.log(err)
    )
  }

  handleEdit(q,i){
    scrollTo(0,0);
    this.editingIndex = i;
    this.isEditing = true;
    this.text = q.title;
    this.index = q.index;
    this._id = q._id;
  }

  updateQuestion(){
    let obj = {
      title: this.text,
      index: this.index,
      _id:this._id
    }
    this.mipsService.updateQuestion(obj).subscribe(
      resp=>{
        Swal.fire("Pregunta actualizada").then(
          resp=>{
            this.questions[this.editingIndex] = obj;
            this.text = "";
            this.index = 999;
            this.isEditing = false;
          }
        )
      },
      err=>console.log(err)
    )
  }

  handleDelete(id){
    let opc = confirm("Eliminar pregunta?");
    if (opc) this.adminService.deleteQuestion('mips',id);
  }

  selectScale(){
    this.trueItems = [];
    this.falseItems = [];
    let index = 0;
    this.questions.map(
      q=>{
        for (let type of q.values){
          if (type.scale == this.selectedScale){
            if (type.value) this.trueItems.push({index:index, score:type.score});
            else this.falseItems.push({index:index, score:type.score});
          }
        }
        index++;
      }
    )
    this.trueItems.sort((a,b)=>b.score - a.score);
    this.falseItems.sort((a,b)=>b.score - a.score);
  }

}
